var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9631 52.5001C22.0297 52.5001 21.1631 52.0001 20.7297 51.1334C20.0964 49.9001 20.5964 48.4001 21.8631 47.7668C24.7631 46.3334 27.2297 44.1334 28.9964 41.4668C29.5964 40.5668 29.5964 39.4334 28.9964 38.5334C27.1964 35.8668 24.7297 33.6668 21.8631 32.2334C20.5964 31.6334 20.0964 30.1334 20.7297 28.8668C21.3297 27.6334 22.8297 27.1334 24.0631 27.7668C27.7297 29.6001 30.8631 32.3668 33.1297 35.7668C34.8297 38.3334 34.8297 41.6668 33.1297 44.2334C30.8631 47.6334 27.7297 50.4001 24.0631 52.2334C23.7297 52.4001 23.3297 52.5001 22.9631 52.5001Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 52.5H43.3334C41.9667 52.5 40.8334 51.3667 40.8334 50C40.8334 48.6333 41.9667 47.5 43.3334 47.5H56.6667C58.0334 47.5 59.1667 48.6333 59.1667 50C59.1667 51.3667 58.0334 52.5 56.6667 52.5Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 75.8334H30C11.9 75.8334 4.16663 68.1 4.16663 50V30C4.16663 11.9 11.9 4.16669 30 4.16669H50C68.1 4.16669 75.8333 11.9 75.8333 30V50C75.8333 68.1 68.1 75.8334 50 75.8334ZM30 9.16669C14.6333 9.16669 9.16663 14.6334 9.16663 30V50C9.16663 65.3667 14.6333 70.8334 30 70.8334H50C65.3666 70.8334 70.8333 65.3667 70.8333 50V30C70.8333 14.6334 65.3666 9.16669 50 9.16669H30Z",
    fill: "#475569"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodePlaceholder);
export default __webpack_public_path__ + "static/media/codePlaceholder.7e6610152aa6542c02f2da7731733797.svg";
export { ForwardRef as ReactComponent };